"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _draftExtend = require("draft-extend");

var _constants = require("draft-plugins/lib/constants");

var _MeetingsProTip = _interopRequireDefault(require("./MeetingsProTip"));

var entityToHTML = function entityToHTML(entity, originalText) {
  return originalText;
};

var _default = (0, _draftExtend.createPlugin)({
  decorators: {
    strategy: _draftExtend.pluginUtils.entityStrategy(_constants.MEETINGS_PRO_TIP_ENTITY_KEY),
    component: _MeetingsProTip.default
  },
  entityToHTML: entityToHTML
});

exports.default = _default;
module.exports = exports.default;